import request from '../../utils/request';

export function getRoutePlans(params) {
  return request(`/route-plans`, {
    method: 'GET',
    params,
  });
}

export function getRoutePlan(params) {
  const { id } = params;
  return request(`/route-plans/${id}`, {
    method: 'GET',
  });
}

export function optimizeRoutePlan(params) {
  const { id } = params;

  return request(`/route-plans/${id}/optimize`, {
    method: 'POST',
    data: params,
  });
}

export function createRoutePlan(params) {
  return request(`/route-plans`, {
    method: 'POST',
    data: params,
  });
}

export function updateRoutePlan(params) {
  const { id } = params;
  delete params.id;
  return request(`/route-plans/${id}`, {
    method: 'PATCH',
    data: params,
  });
}

export function addOrdersToRoutePlan(params) {
  const { id } = params;
  return request(`/route-plans/${id}/orders`, {
    method: 'POST',
    data: params,
  });
}

export function deleteRoutePlan(params) {
  const { id } = params;
  return request(`/route-plans/${id}`, {
    method: 'DELETE',
  });
}

export function reorderRoutePlan(params) {
  const { id } = params;
  return request(`/route-plans/${id}/reorder-orders`, {
    method: 'POST',
    data: params,
  });
}
export const dispatchRoutePlan = (params) => {
  const { id } = params;
  return request(`/route-plans/${id}/dispatch-drivers`, {
    method: 'POST',
    data: params,
  });
};

export const lockRiderInsideRoutePlan = (params) => {
  const { id } = params;
  return request(`/route-plans/${id}/lock-rider`, {
    method: 'POST',
    data: params,
  });
};

export const removeRidersInsideRoutePlan = (params) => {
  const { id } = params;
  return request(`/route-plans/${id}/remove-riders`, {
    method: 'POST',
    data: params,
  });
};

export const removeOrdersInsideRoutePlan = (params) => {
  const { id } = params;
  return request(`/route-plans/${id}/remove-orders`, {
    method: 'POST',
    data: params,
  });
};

export const swapOrdersToRiderRoutePlan = (params) => {
  const { id } = params;
  return request(`/route-plans/${id}/swap-orders-to-rider`, {
    method: 'POST',
    data: params,
  });
};
